import React from 'react';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import CopyToClipBoardv2 from 'app/components/CopyToClipboard/index';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/paraiso-dark.css';
import CopyIcon from 'components/Icons/CopyIcon';
require('codemirror/mode/javascript/javascript');
require('codemirror/mode/php/php');
require('codemirror/mode/python/python');
require('codemirror/mode/go/go');
var styles = {
    copy: {
        position: 'absolute',
        top: -36,
        right: 0,
        fontSize: 12,
    },
    btn: {
        background: '#dedede',
        padding: '4px 16px',
        borderRadius: 5,
    },
};
var LanguageCode = function (_a) {
    var code = _a.code, language = _a.language;
    return React.createElement("div", { className: "mt2", style: { position: 'relative' } },
        React.createElement("div", { style: styles.copy },
            React.createElement(CopyToClipBoardv2, { copyText: code },
                React.createElement(CopyIcon, null))),
        React.createElement(CodeMirror, { className: "code-container", value: code, options: {
                mode: language,
                theme: 'paraiso-dark',
                lineNumbers: true,
            } }));
};
export default LanguageCode;
